// removed by extract-text-webpack-plugin
module.exports = {"chipsWrapper":"_2x0gSvivOpt0ssYiwFqnj","chipsButton":"_2cV4ZRp3QidivIRCpoC9g_","active":"SGSeOI1KZcDvr2dfcZzTK","solid":"_3V1VALWGj078BdcY2GT4dS","separated":"_1t2S2qr9iH1P2wBedN5aYY","switcher":"w4PKIKVIxfy1AcfL7l_6c","switcher-transparent":"_1yTonr-i3CZze2IS0DDDhD","square":"_1X3RjcqCVG47bXAlX0TsbH","squareMobile":"_2p8-la8J-DNuOrrCpfxb6G","switcherPackages":"TGEwXLYFQO_DKmRigEb0a","switcherMobile":"_1zV2hDOlMeDtzO7dxoRM0x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HomePagePropertiesChips/HomePagePropertiesChips.scss
// module id = 1610
// module chunks = 0